module.exports = __webpack_public_path__ + "static/cart02-0daa254ccc5e1caf647e51001cbc75d3.svg";